import { useContext } from 'react';
import { NotificationContext } from '../contexts/NotificationContext';

export function useNotifications() {
  const { addNotification } = useContext(NotificationContext);
  return { addNotification };
}
